import palette from 'google-material-color'
import api from '../api/index'
const state = {
  messages: [],
  userId: '',
  newMessage: '',
  messageToSend: '',
  userColours: {}
}

const mutations = {
  setMessages: function (state, payload) {
    state.messages = payload
  },
  setUserId: function (state, payload) {
    state.userId = payload
  },
  setNewMessage: function (state, payload) {
    state.newMessage = payload
  },
  setSendMessage: function (state, payload) {
    state.messageToSend = payload
    state.newMessage = ''
  },
  addMessage: function (state, payload) {
    state.messages.push(payload)
  },
  addMessages: function (state, payload) {
    let temp = payload.concat(state.messages)
    state.messages = temp
  },
  setColours: function (state, payload) {
    state.userColours = payload
  }
}

const actions = {
  loadId: function (context, eid) {
    if (localStorage.getItem(eid) !== null) {
      let storage = JSON.parse(localStorage.getItem(eid))
      if (typeof (storage.chatId) !== 'undefined') {
        context.commit('setUserId', storage.chatId)
      }
    }
  },
  loadNewOpenChannel: function (context, ID) {
    api.addChat(ID, function (data) {
      location.reload()
    })
  },
  login: function (context, ID) {
    let storage = {
      chatId: ID
    }
    localStorage.setItem(context.getters.eid, JSON.stringify(storage))
    context.commit('setUserId', ID)
  },
  loadNewMessage: function (context, message) {
    context.commit('setNewMessage', message)
  },
  sendMessage: function (context, message) {
    context.commit('setSendMessage', message)
  },
  initMessages: function (context, messageList) {
    context.commit('setMessages', messageList)
    context.dispatch('loadColours', messageList)
  },
  addMessage: function (context, message) {
    context.commit('addMessage', message)
    context.commit('setSendMessage', '')
    context.dispatch('loadColours', context.state.messages)
  },
  addMessages: function (context, messageList) {
    context.commit('addMessages', messageList)
    context.dispatch('loadColours', context.state.messages)
  },
  loadColours: function (context, messageList) {
    let colours = []
    for (var colour in palette.palette) {
      if (palette.palette.hasOwnProperty(colour)) {
        colours.push(palette.palette[colour][500])
      }
    }
    let colourIndex = 0
    let colouredUsers = {}
    let processed = []
    for (var i = messageList.length - 1; i >= 0; i--) {
      let userId = messageList[i]._sender.userId
      if (processed.indexOf(userId) < 0) {
        processed.push(userId)
        colouredUsers[userId] = colours[colourIndex]
        if (colourIndex < 16) {
          colourIndex += 1
        } else {
          colourIndex = 0
        }
      }
    }
    context.commit('setColours', colouredUsers)
  }
}

const getters = {
  newMessage: state => {
    return state.newMessage
  },
  messageToSend: state => {
    return state.messageToSend
  },
  userId: state => {
    return state.userId
  },
  uniqueId: state => {
    return state.uniqueId
  },
  messages: state => {
    return state.messages
  },
  userColours: state => {
    return state.userColours
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sendBird.js